import { createOrUpdateMetaTag } from '@diagentech/exprworks-ui-components';
import React, { useEffect } from 'react';

import { useSeoMeta } from '@/components/seo/useSeoMeta';
import { useSetDocumentLanguage } from '@/components/seo/useSetDocumentLanguage';
import { useUpdateHiddenSeoElements } from '@/components/seo/useUpdateHiddenSeoElements';

export const SeoMetaInfo: React.FC = () => {
  const meta = useSeoMeta();

  useSetDocumentLanguage();
  useUpdateHiddenSeoElements(meta);

  useEffect(() => {
    if (meta) {
      document.title = meta.title;
      createOrUpdateMetaTag('name', 'robots', meta.robots);
      createOrUpdateMetaTag('name', 'title', meta.title);
      createOrUpdateMetaTag('name', 'description', meta.description);
      createOrUpdateMetaTag('name', 'keywords', meta.keywords);
      createOrUpdateMetaTag('property', 'og:title', meta.title);
      createOrUpdateMetaTag('property', 'og:description', meta.description);
      createOrUpdateMetaTag('property', 'og:type', 'website');
    }
  }, [meta]);

  return null;
};
